import { logger } from "./logger"
import { config } from "./configService"
import { InAppMessaging } from "martti-agent-services"

export const inAppMessaging = new InAppMessaging({ logger, config })
